// Module
var code = "<title>Customily - Sign in</title> <div ng-cloak class=\"h100\"> <vue-component name=\"SignIn\" class=\"h100\"/> </div> ";
// Exports
module.exports = code;